import {hasUnlockPlusTokenInUrl, PLUS_CUG_TYPE} from './privateDeals'

export interface TokenFromUrlParams {
  token?: string
  priceWatchId?: string
}

/**
 * Determines the Plus CUG type based on membership status and URL parameters.
 * @param isMembersPlus - Whether the user is a Plus member
 * @param urlParams - URL parameters containing token and priceWatchId
 * @param isBrandOffersLockedByDefault - Whether brand offers are locked by default
 * @returns Array containing Plus CUG type if eligible, empty array otherwise
 */
export const getPlusCugType = (
  isMembersPlus: boolean,
  urlParams: TokenFromUrlParams = {},
  isBrandOffersLockedByDefault = true
) =>
  isMembersPlus ||
  hasUnlockPlusTokenInUrl(urlParams) ||
  !isBrandOffersLockedByDefault
    ? [PLUS_CUG_TYPE]
    : []
